import type * as React from 'react';

import type { BlockProps } from '@gitbook/slate-react';
import { Divider } from '@gitbook/spine-react';

import { BlockWrapper, VoidBlockFrame } from '../common';

/*
 * Renderer for a divider block.
 */
export function BlockDivider(props: BlockProps): React.ReactElement {
    const { attributes } = props;

    return (
        <BlockWrapper {...props}>
            <VoidBlockFrame {...props}>
                <Divider {...attributes} />
            </VoidBlockFrame>
        </BlockWrapper>
    );
}
